import { Outlet } from "react-router-dom";
import { NavigationProvider } from "./shared/context/navigation-context";
import { SearchRepositoryProvider } from "./shared/context/search-repository-context";
import { IFrameProvider } from "@presentation/shared/context/iframe-context";
import { ExtraTabProvider } from "@presentation/shared/context/extra-tab-context";

function App() {
  return (
    <IFrameProvider>
      <NavigationProvider>
        <ExtraTabProvider>
          <SearchRepositoryProvider>
            <div className="App h-screen w-screen flex flex-col font-base">
              <Outlet />
            </div>
          </SearchRepositoryProvider>
        </ExtraTabProvider>
      </NavigationProvider>
    </IFrameProvider>
  );
}

export default App;
